import pdfPlaceholder from 'pdf_placeholder.svg';

$(() => {
  const { disableBodyScroll } = window.bodyScrollLock;

  const uploadInput = $('#claim-listing-upload');

  uploadInput.change(() => {
    const images = Array.from(uploadInput[0].files);

    images.forEach(file => {
      const imageURL = URL.createObjectURL(file);
      $('.modal-images-preview-wrapper.claim-listing').append(`
        <div>
          <section class="delete-image">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="0.646447" y1="12.6464" x2="12.6464" y2="0.646446" stroke="#073655"/>
              <line y1="-0.5" x2="16.9706" y2="-0.5" transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 12 13)" stroke="#073655"/>
            </svg>
          </section>
          <img src="${
            file.name.includes('.pdf') ? pdfPlaceholder : imageURL
          }" alt="${file.name}" title="${file.name}" />
        </div>
      `);
    });

    Array.from($('.delete-image')).forEach(elem => {
      $(elem).click(() => {
        $(elem)[0].parentElement.remove();
      });
    });
  });

  // Show Claim Listing modal
  $('.claim_listing_toggle').on('click', () => {
    $('#claim_listing_modal_container').removeClass('hidden');

    disableBodyScroll($('#claim_listing_modal_container'));

    localStorage.setItem('claim_listing', true);

    window.history.pushState(
      null,
      null,
      `${window.location.pathname}#claim-listing`
    );
  });

  // Clear form after submitting
  $(() => {
    $('#new_claim').bind('ajax:complete', () => {
      $('#claim_name').val('');
      $('#claim_email').val('');
      $('#claim_message').val('');
      $('#claim-listing-upload').val('');
      $('.modal-images-preview-wrapper.claim-listing').html('');
    });
  });
});
